import { render, staticRenderFns } from "./XhProduct.vue?vue&type=template&id=31eca6d6&scoped=true"
import script from "./XhProduct.vue?vue&type=script&lang=js"
export * from "./XhProduct.vue?vue&type=script&lang=js"
import style0 from "./XhProduct.vue?vue&type=style&index=0&id=31eca6d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eca6d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31eca6d6')) {
      api.createRecord('31eca6d6', component.options)
    } else {
      api.reload('31eca6d6', component.options)
    }
    module.hot.accept("./XhProduct.vue?vue&type=template&id=31eca6d6&scoped=true", function () {
      api.rerender('31eca6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhProduct.vue"
export default component.exports